<template>
  <div class="w-96 h-full border-r border-gray-300 overflow-y-auto fancy-scrollbar">
    <ul class="divide-y divide-gray-300">
      <li class="px-6 py-4">
        <ContactCard :contact-id="contactId" />
      </li>
      <li>
        <CollapsableSection :title="$t('contact.about')" expanded-by-default>
          <template #default>
            <ContactProperties :contact-id="contactId" />
          </template>
        </CollapsableSection>
      </li>
      <li>
        <UserManager :contact-id="contactId" />
      </li>
    </ul>
    <div />
  </div>
</template>

<script>
import ContactCard from './ContactCard.vue';
import CollapsableSection from './CollapsableSection.vue';
import ContactProperties from './ContactProperties.vue';
import UserManager from './UserManager.vue';

export default {
  components: {
    ContactCard,
    CollapsableSection,
    ContactProperties,
    UserManager,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId];
    },
    contactRequestsTitle() {
      const { contactRequestsCount = 0 } = this.contact || {};

      return ['Requests', contactRequestsCount ? `(${contactRequestsCount})` : false]
        .filter(Boolean)
        .join(' ');
    },
  },
};
</script>
